export default {
  data() {
    return {
      _menuLeaveTimer: null
    }
  },
  methods: {
    fnchangeSelect(_index) {
      if (this._menuLeaveTimer) {
        clearTimeout(this._menuLeaveTimer)
        this._menuLeaveTimer = null
      }
      if (_index > 0) {
        this.isOpen = true
        this.selectIndex = _index
      } else {
        this._menuLeaveTimer = setTimeout(() => {
          this.isOpen = false
          this.selectIndex = '0'
        }, 200)
      }
    },
    fnOpenGb(e) {
      if (e && e.stopPropagation) e.stopPropagation()
      let u = {}
      try {
        u = JSON.parse(localStorage.getItem('User-Info') || localStorage.getItem('UserInfo') || '{}')
      } catch (ex) {}
      const adminHost = /\.local$|^localhost$|^127\.0\.0\.1$/.test(location.hostname)
        ? 'http://admin.zgjkj.local'
        : 'http://admin.zgjkj.com'
      const pid = u.authorize_project_id || u.project_id || u.projectId || u.id || ''
      const first = String(pid).split(',')[0]
      window.open(
        adminHost + '/monitor/gb.html?project_id=' + encodeURIComponent(first),
        '_blank'
      )
    },
    fnOpenCodeTrain(e) {
      if (e && e.stopPropagation) e.stopPropagation()
      if (typeof window.ctShowPage === 'function') {
        window.ctShowPage()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/selectMenuExtras.js